<template>
  <div class="modal_wrapper" :style="{backgroundColor: backgroundColor}">
    <div class="option_modal">
      <div class="modal_container">
        <div class="modal_header">
          <img :src="option" height="25px" />
          {{ title }}
        </div>
        <div class="modal_body">
          <div class="body">
            <div class="password_enable_flag">
              <div class="password_enable_flag_label label">
                {{ passwordEnableFlagLabel }}
              </div>
              <div class="option_radio_buttons">
                <label>
                  <input
                    type="radio"
                    name="password_enable_flag"
                    class="option_radio_button"
                    :checked="isPasswordEnableFlag"
                    @click="isPasswordEnableFlag = true"
                  />
                  {{ UseLabel }}
                </label>
                <label>
                  <input
                    type="radio"
                    name="password_enable_flag"
                    class="option_radio_button"
                    :checked="!isPasswordEnableFlag"
                    @click="isPasswordEnableFlag = false"
                  />
                  {{ UnUseLabel }}
                </label>
              </div>
              <input
                type="button"
                class="change_password_enable_flag_button"
                :value="changeButton"
                @click="showConfirmUsePasswordModal = true"
              />
            </div>
            <div class="change_init_password">
              <div class="change_init_password_label label">
                {{ initPasswordLabel }}
              </div>
              <label class="change_init_login_label">
                {{ passwordChangelabel }}
              </label>
              <input
                type="button"
                :value="changePasswordButton"
                class="change_password_button"
                @click="showChangePasswordModal = true"
                :disabled="!passwordEnableFlag"
                :style="{backgroundColor: buttonColor}"
              />
            </div>
            <div class="login_value">
              <div class="login_value_title_label label">
                {{ loginValueTitleLabel }}
              </div>
              <label class="login_value_label">
                {{ loginValueLabel }}
              </label>
              <input
                type="button"
                class="change_login_value_button"
                :value="changeButton"
                @click="showChangeLoginLabelModal = true"
              />
            </div>
            <div class="auto_logout">
              <div class="auto_logout_label label">
                {{ autoLogoutLabel }}
              </div>
              <div class="option_radio_buttons">
                <label>
                  <input
                    type="radio"
                    name="auto_logout"
                    class="option_radio_button"
                    :checked="showSleepChange"
                    @click="showSleepChange = true"
                  />
                  {{ OnLabel }}
                </label>
                <label>
                  <input
                    type="radio"
                    name="auto_logout"
                    class="option_radio_button"
                    :checked="!showSleepChange"
                    @click="showSleepChange = false"
                  />
                  {{ OffLabel }}
                </label>
              </div>
              <div class="sleep_function" v-if="showSleepChange">
                <select
                  class="sleep_function_drop_down_list"
                  @change="inputUpdate(sleepFunctionTimeList)"
                >
                  <option disabled selected value="">
                    {{ autoLogoutSecondLabel }}
                  </option>
                  <option
                    v-for="n in sleepFunctionTimeList"
                    :key="n"
                    :value="n"
                  >
                    {{ n / 3600 }}時間
                  </option>
                </select>
              </div>
              <input
                type="button"
                class="change_auto_logout_flag_button"
                :value="changeButton"
                @click="showConfirmAutoLogoutModal = true"
              />
            </div>
            <div class="show_rates">
              <div class="show_rates_label label">
                {{ showRatesLabel }}
              </div>
              <div class="option_radio_buttons">
                <label>
                  <input
                    type="radio"
                    name="show_rates"
                    class="option_radio_button"
                    :checked="showRatesChange"
                    @click="showRatesChange = true"
                  />
                  {{ OnLabel }}
                </label>
                <label>
                  <input
                    type="radio"
                    name="show_rates"
                    class="option_radio_button"
                    :checked="!showRatesChange"
                    @click="showRatesChange = false"
                  />
                  {{ OffLabel }}
                </label>
              </div>
              <input
                type="button"
                class="change_rates_flag_button"
                :value="changeButton"
                @click="showConfirmRatesModal = true"
              />
            </div>
            <div class="logout_value">
              <div class="logout_value_title_label label">
                {{ logoutValueTitleLabel }}
              </div>
              <label class="logout_value_label">
                {{ logoutValueLabel }}
              </label>
              <input
                type="button"
                class="change_logout_value_button"
                :value="changeButton"
                @click="showChangeLogoutLabelModal = true"
                :disabled="!ratingQuarityEnableFlag"
                :style="{backgroundColor: logoutValueButtonColor}"
              />
            </div>
            <div class="keyboard_type">
              <div class="keyboard_type_label label">
                {{ keyboardTypeTitleLabel }}
              </div>
              <div class="option_radio_buttons">
                <label>
                  <input
                    type="radio"
                    name="keyboard_type"
                    class="option_radio_button"
                    :checked="keyboardType == 0"
                    @click="keyboardType = 0"
                  />
                  {{ numbersAndPunctuationLabel }}
                </label>
                <label>
                  <input
                    type="radio"
                    name="keyboard_type"
                    class="option_radio_button"
                    :checked="keyboardType == 1"
                    @click="keyboardType = 1"
                  />
                  {{ numberPadLabel }}
                </label>
              </div>
              <input
                type="button"
                class="change_keyboard_type_button"
                :value="changeButton"
                @click="showConfirmKeyboardTypeModal = true"
              />
            </div>
            <div class="status_value">
              <div class="status_value_title_label label">
                {{ statusValueTitleLabel }}
              </div>
              <label class="status_value_label">{{ statusValueLabel }}</label>
              <input
                type="button"
                class="change_status_value_button"
                :value="changeButton"
                @click="showChangeStatusLabelModal = true"
              />
            </div>
            <div class="display_PositionJob_flag">
              <div class="password_enable_flag_label label">
                {{ displayPositionJobFlagLabel }}
              </div>
              <div class="option_radio_buttons">
                <label>
                  <input
                    type="radio"
                    name="display_PositionJob_flag"
                    class="option_radio_button"
                    :checked="showPositionJobFlag"
                    @click="showPositionJobFlag = true"
                  />
                  {{ VisibleLabel }}
                </label>
                <label>
                  <input
                    type="radio"
                    name="display_PositionJob_flag"
                    class="option_radio_button"
                    :checked="!showPositionJobFlag"
                    @click="showPositionJobFlag = false"
                  />
                  {{ UnVisibleLabel }}
                </label>
              </div>
              <input
                type="button"
                class="change_display_PositionJob_button"
                :value="changeButton"
                @click="showDisplayPositionJobModal = true"
              />
            </div>
            <div class="custom_message">
              <div class="custom_message_label label">
                {{ customMessageLabel }}
              </div>
              <div class="option_radio_buttons">
                <label>
                  <input
                    type="radio"
                    name="custom_message"
                    class="option_radio_button"
                    :checked="customMessageType == 0"
                    @click="customMessageType = 0"
                  />
                  {{ FreeTemplateLabel }}
                </label>
                <label>
                  <input
                    type="radio"
                    name="custom_message"
                    class="option_radio_button"
                    :checked="customMessageType == 1"
                    @click="customMessageType = 1"
                  />
                  {{ TemplateLabel }}
                </label>
              </div>
              <input
                type="button"
                class="change_custom_message_button"
                :value="changeButton"
                @click="showCustomMessageModal = true"
              />
            </div>
          </div>
          <div class="modal_buttons">
            <input
              type="button"
              :value="cancelButton"
              class="cancel_button"
              @click="$emit('close')"
            />
          </div>
          <div class="modal_window" v-if="showChangePasswordModal">
            <changePasswordModalWindow
              :mode="mode"
              @close="close"
              @change="changePassword"
            >
            </changePasswordModalWindow>
          </div>
          <div class="modal_window" v-if="showChangeLoginLabelModal">
            <changeLoginLabelModalWindow @close="close">
            </changeLoginLabelModalWindow>
          </div>
          <div class="modal_window" v-if="showChangeLogoutLabelModal">
            <changeLogoutLabelModalWindow @close="close">
            </changeLogoutLabelModalWindow>
          </div>
          <div class="modal_window" v-if="showConfirmAutoLogoutModal">
            <confirmModalWindow
              :question="changeAutoLogoutWord"
              @close="close"
              @ok="changeSleep"
            >
            </confirmModalWindow>
          </div>
          <div class="modal_window" v-if="showConfirmRatesModal">
            <confirmModalWindow
              :question="changeRatesWord"
              @close="close"
              @ok="changeRates"
            >
            </confirmModalWindow>
          </div>
          <div class="modal_window" v-if="showConfirmKeyboardTypeModal">
            <confirmModalWindow
              :question="changeKeyboardTypeWord"
              @close="close"
              @ok="changeKeyboardType"
            >
            </confirmModalWindow>
          </div>
          <div class="modal_window" v-if="showConfirmUsePasswordModal">
            <changeInitLoginPasswordModalWindow
              :question="changePasswordEnableFlagWord"
              :flag="isPasswordEnableFlag"
              @close="close"
            >
            </changeInitLoginPasswordModalWindow>
          </div>
          <div class="modal_window" v-if="showChangeStatusLabelModal">
            <changeStatusLabelModalWindow @close="close">
            </changeStatusLabelModalWindow>
          </div>
          <div class="modal_window" v-if="showCompleteModal">
            <completeModalWindow :question="completeWord" @close="close">
            </completeModalWindow>
          </div>
          <div class="loading_modal_window" v-if="showloadingModal">
            <loadingModalWindow @close="close"> </loadingModalWindow>
          </div>
          <div class="modal_window" v-if="showDisplayPositionJobModal">
            <confirmModalWindow
              :question="changePositionJobFlagWord"
              @close="close"
              @ok="changePositionJobEnable"
            >
            </confirmModalWindow>
          </div>
          <div class="modal_window" v-if="showCustomMessageModal">
            <confirmModalWindow
              :question="changeCustomMessageTypeWord"
              @close="close"
              @ok="changeCustomMessageType"
            >
            </confirmModalWindow>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import changePasswordModalWindow from './changePasswordModalWindow.vue'
import changeInitLoginPasswordModalWindow from './changeInitLoginPasswordModalWindow.vue'
import changeLoginLabelModalWindow from './changeLoginLabelModalWindow.vue'
import changeLogoutLabelModalWindow from './changeLogoutLabelModalWindow.vue'
import changeStatusLabelModalWindow from './changeStatusLabelModalWindow.vue'
import confirmModalWindow from './confirmModalWindow.vue'
import completeModalWindow from './finishModalWindow.vue'
import loadingModalWindow from '../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      option: require('../../img/option_re.png'),
      title: '共通設定',
      initPasswordLabel: '初期パスワード設定',
      changePasswordButton: 'パスワード変更',
      showRatesLabel: '評価管理機能設定',
      autoLogoutLabel: '自動ログアウト設定',
      passwordEnableFlagLabel: 'アプリパスワード使用設定',
      displayPositionJobFlagLabel: 'アプリ一覧画面での職種・役職　省略表示設定',
      OnLabel: 'ON',
      OffLabel: 'OFF',
      passwordChangelabel: '初期パスワードを変更する',
      UseLabel: '使用する',
      UnUseLabel: '使用しない',
      VisibleLabel: '表示する',
      UnVisibleLabel: '表示しない',
      logoutValueTitleLabel: '評価機能説明文言設定',
      loginValueTitleLabel: 'ログイン時文言設定',
      logoutValueLabel: 'アプリで評価を実施する際に表示する文言を変更する',
      loginValueLabel: 'アプリログイン時に表示する文言を変更する',
      keyboardTypeTitleLabel: 'アプリ ユーザID入力キーボードタイプ設定',
      numbersAndPunctuationLabel: '英数字',
      numberPadLabel: '数字のみ',
      statusValueTitleLabel: 'ステータス文言設定',
      statusValueLabel:
        'アプリでステータス設定する際に表示する\n各ステータスの文言を変更する',
      customMessageLabel: 'カスタムメッセージ設定',
      FreeTemplateLabel: '自由入力+定型文',
      TemplateLabel: '定型文のみ',
      changeButton: '変更',
      cancelButton: 'キャンセル',
      sleepFunctionTimeList: [
        3600, // 1時間
        10800, // 3時間
        21600, // 6時間
        28800, // 8時間
        43200, // 12時間
        64800, // 18時間
        86400 // 24時間
      ],
      keyboardType: 0,
      changeAutoLogoutWord: '自動ログアウト設定を変更しますか？',
      changeRatesWord: '評価管理機能設定を変更しますか？',
      changeKeyboardTypeWord: 'キーボードタイプを変更しますか？',
      changePositionJobFlagWord: '職種・役職　省略表示を変更しますか？',
      changeCustomMessageTypeWord: 'カスタムメッセージ設定を変更しますか？',
      completeWord: '',
      mode: 'master',
      showSleepChange: '',
      showRatesChange: '',
      isPasswordEnableFlag: '',
      autoLogoutSecond: 0,
      customMessageType: 0,
      showPositionJobFlag: '',
      showChangePasswordModal: false,
      showConfirmAutoLogoutModal: false,
      showConfirmRatesModal: false,
      showConfirmKeyboardTypeModal: false,
      showChangeLoginLabelModal: false,
      showChangeLogoutLabelModal: false,
      showConfirmUsePasswordModal: false,
      showChangeStatusLabelModal: false,
      showCompleteModal: false,
      showloadingModal: false,
      showDisplayPositionJobModal: false,
      showCustomMessageModal: false
    }
  },
  components: {
    changePasswordModalWindow,
    changeInitLoginPasswordModalWindow,
    confirmModalWindow,
    completeModalWindow,
    loadingModalWindow,
    changeLoginLabelModalWindow,
    changeLogoutLabelModalWindow,
    changeStatusLabelModalWindow
  },
  computed: {
    errorMsg() {
      return this.$store.state.error.errorMsg
    },
    passwordEnableFlag() {
      return this.$store.state.masters.passwordEnableFlagMaster
        .passwordEnableFlag
    },
    ratingQuarityEnableFlag() {
      return this.$store.state.masters.logoutFlagMaster.ratingQuarityEnableFlag
    },
    backgroundColor() {
      if (
        this.showChangePasswordModal === true ||
        this.showConfirmAutoLogoutModal === true ||
        this.showCompleteModal === true ||
        this.showConfirmRatesModal === true ||
        this.showConfirmUsePasswordModal === true ||
        this.showChangeLoginLabelModal === true ||
        this.showChangeLogoutLabelModal === true ||
        this.showConfirmKeyboardTypeModal === true ||
        this.showChangeStatusLabelModal === true
      ) {
        return ''
      } else {
        return 'rgba(0, 0, 0, .5)'
      }
    },
    buttonColor() {
      if (this.passwordEnableFlag) {
        return '#00afa8'
      } else {
        return '#C0C0C0'
      }
    },
    logoutValueButtonColor() {
      if (this.ratingQuarityEnableFlag) {
        return '#00afa8'
      } else {
        return '#C0C0C0'
      }
    },
    autoLogoutSecondLabel() {
      return (
        parseInt(
          this.$store.state.masters.logoutFlagMaster.autoLogoutSecond / 3600
        ) + '時間'
      )
    },
    changePasswordEnableFlagWord() {
      if (this.isPasswordEnableFlag) {
        return 'パスワード機能を有効としますか？<br/>有効とする場合、初期パスワードを設定してください。<br/>設定したパスワードが全ユーザに適用されます。'
      } else {
        return 'パスワード機能を無効としますか？<br/>無効とする場合、全ユーザがユーザIDのみで<br/>ログインできるようになります。'
      }
    }
  },
  async created() {
    this.showloadingModal = true
    try {
      // マスターデータの更新はひとつ前の処理で完了している
      this.showSleepChange =
        this.$store.state.masters.logoutFlagMaster.autoLogoutEnableFlag
      this.showRatesChange =
        this.$store.state.masters.ratesFlagMaster.ratingQuarityEnableFlag
      this.isPasswordEnableFlag =
        this.$store.state.masters.passwordEnableFlagMaster.passwordEnableFlag
      this.keyboardType = parseInt(
        this.$store.state.masters.masterData.keyboardType
      )
      this.showPositionJobFlag =
        this.$store.state.masters.masterData.positionJobEnableFlag
      this.autoLogoutSecond = parseInt(
        this.$store.state.masters.logoutFlagMaster.autoLogoutSecond
      )
      this.customMessageType = parseInt(
        this.$store.state.masters.masterData.customMessageType
      )
    } catch (error) {
      // 通信は前段で実施済みとするため parseIntのエラーしかキャッチしないため
      // 発生しないケースとなるが処理としては入れておく
      let eventNumber = this.$store.state.error.errorCode.errorCode_430001
      let eventType = 9
      let reason = 'MSGCRC0005'
      this.completeWord =
        this.errorMsg.MSGCRC0005.name +
        this.errorMsg.MSGCRC0005.value +
        'エラーコード：{' +
        eventNumber +
        '}'
      try {
        this.$store.dispatch('masters/writeLog', {
          eventNumber,
          eventType,
          reason
        })
      } catch (error) {}
      this.showCompleteModal = true
    }
    this.showloadingModal = false
  },
  methods: {
    async close() {
      this.showChangePasswordModal = false
      this.showConfirmAutoLogoutModal = false
      this.showConfirmRatesModal = false
      this.showCompleteModal = false
      this.showConfirmUsePasswordModal = false
      this.showChangeLoginLabelModal = false
      this.showChangeLogoutLabelModal = false
      this.showConfirmKeyboardTypeModal = false
      this.showChangeStatusLabelModal = false
      this.showDisplayPositionJobModal = false
      this.showCustomMessageModal = false
    },
    changePassword() {
      // パスワード変更のコードを記述
      this.showChangePasswordModal = false
    },
    async changePositionJobEnable() {
      this.showloadingModal = true
      try {
        this.showDisplayPositionJobModal = false
        await this.$store.dispatch(
          'masters/changeDispPositionJob',
          this.showPositionJobFlag
        )
        this.completeWord = '職種・役職　省略表示を変更しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_430009
        let eventType = 3
        let reason = 'MSGCRC0086 '
        if (error.response) {
          this.completeWord =
            this.errorMsg.MSGCRC0086.name +
            this.errorMsg.MSGCRC0086.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.completeWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showCompleteModal = true
      }
      this.showloadingModal = false
    },
    inputUpdate(e) {
      this.autoLogoutSecond = event.target.value
    },
    async changeSleep() {
      // 自動ログアウト設定変更のコードを記述
      this.showloadingModal = true
      this.showConfirmAutoLogoutModal = false
      try {
        if (this.showSleepChange === true) {
          await this.$store.dispatch('masters/changeAutoLogout', {
            autoLogoutSecond: this.autoLogoutSecond,
            showSleepChange: this.showSleepChange
          })
        } else {
          await this.$store.dispatch('masters/changeAutoLogout', {
            showSleepChange: this.showSleepChange
          })
        }
        this.completeWord = '自動ログアウト設定を変更しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_430002
        let eventType = 3
        let reason = 'MSGCRC0087 '
        if (error.response) {
          this.completeWord =
            this.errorMsg.MSGCRC0087.name +
            this.errorMsg.MSGCRC0087.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.completeWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showCompleteModal = true
      }
      this.showloadingModal = false
    },
    async changeRates() {
      // 自動ログアウト設定変更のコードを記述
      this.showloadingModal = true
      try {
        this.showConfirmRatesModal = false
        await this.$store.dispatch(
          'masters/changeShowRates',
          this.showRatesChange
        )
        this.completeWord = '評価管理機能設定を変更しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_430003
        let eventType = 3
        let reason = 'MSGCRC0088 '
        if (error.response) {
          this.completeWord =
            this.errorMsg.MSGCRC0088.name +
            this.errorMsg.MSGCRC0088.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.completeWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showCompleteModal = true
      }
      this.showloadingModal = false
    },
    async changeKeyboardType() {
      // 自動ログアウト設定変更のコードを記述
      this.showloadingModal = true
      try {
        this.showConfirmKeyboardTypeModal = false
        await this.$store.dispatch(
          'masters/changeKeyboardType',
          this.keyboardType
        )
        this.completeWord = 'キーボードタイプを変更しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_430009
        let eventType = 3
        let reason = 'MSGCRC0145 '
        if (error.response) {
          this.completeWord =
            this.errorMsg.MSGCRC0145.name +
            this.errorMsg.MSGCRC0145.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.completeWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showCompleteModal = true
      }
      this.showloadingModal = false
    },
    async changeCustomMessageType() {
      // 自動ログアウト設定変更のコードを記述
      this.showloadingModal = true
      try {
        this.showCustomMessageModal = false
        await this.$store.dispatch(
          'masters/changeCustomMessageType',
          this.customMessageType
        )
        this.completeWord = 'カスタムメッセージ設定を変更しました。'
        this.showCompleteModal = true
      } catch (error) {
        let eventNumber = this.$store.state.error.errorCode.errorCode_430011
        let eventType = 3
        let reason = 'MSGCRC0313 '
        if (error.response) {
          this.completeWord =
            this.errorMsg.MSGCRC0313.name +
            this.errorMsg.MSGCRC0313.value +
            'エラーコード：{' +
            eventNumber +
            '}'
          reason += error.response.status
        } else {
          reason = 'MSGCRC0005'
          eventType = 9
          this.completeWord =
            this.errorMsg.MSGCRC0005.name +
            this.errorMsg.MSGCRC0005.value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
        try {
          this.$store.dispatch('masters/writeLog', {
            eventNumber,
            eventType,
            reason
          })
        } catch (error) {}
        this.showCompleteModal = true
      }
      this.showloadingModal = false
    }
  }
}
</script>
<style scoped>
.modal_container {
  width: 635px;
  height: 566px;
}
.modal_body {
  height: 618px;
  color: #9b9b9b;
  width: 100%;
}
.body {
  height: 405px;
  padding-top: 20px;
  overflow-y: scroll;
  margin-top: 20px;
  padding: 0 55px;
}
</style>



// WEBPACK FOOTER //
// src/components/modalWindow/optionModalWindow.vue